<div class="well m-0 p-0" style="background-color: #fff;" >
      <form  [formGroup]="confirmarFichaInscricaoForm" novalidate role="form">

        <!-- INÍCIO DO TIPO COTISTA -->
          <div class="row m-1">
            <div class="col-sm-6 p-1">
              <fieldset class="border rounded backgroundColor-fieldset">
                <legend class="float-none w-auto">CPF</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.cpf | cpf }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-6 p-1" *ngIf="isExibeOpcaoCotista">
              <fieldset class="border rounded backgroundColor-fieldset">
                <legend class="float-none w-auto">Tipo Cotista</legend>
                <div class="text-start">
                  <label>{{ getDescricaoById(confirmacaoFichaInscricao.codTpCotista, 'cotista') }}</label>
                </div>
              </fieldset>
            </div>
          </div>
          <!-- FIM DO TIPO COTISTA -->

          <!-- INÍCIO DA IDENTIFICAÇÃO -->
          <div class="row m-1">
            <div class="col-sm-4 p-1">
              <fieldset class="border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Nome</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.nome }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-4 p-1">
              <fieldset class="border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Mãe</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.mae }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-4 p-1">
              <fieldset class="border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Pai</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.pai }}</label>
                </div>
              </fieldset>
            </div>
          </div>
          <!-- FIM DA IDENTIFICAÇÃO -->

          <!-- INÍCIO DO NASCIMENTO / IDENTIDADE / OAB -->
          <div class="row m-1">
            <div class="col-sm-3 p-1">
              <fieldset class="border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Nascimento</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.dtNascimento | DateFormat }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-3 p-1">
              <fieldset class="border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Identidade</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.rg }}
                          {{ (confirmacaoFichaInscricao.rgOrgao === '' || confirmacaoFichaInscricao.rgOrgao === null) ? '' : ' / ' + confirmacaoFichaInscricao.rgOrgao }}
                          {{ (confirmacaoFichaInscricao.rgUf === '' || confirmacaoFichaInscricao.rgUf === null) ? '' : ' - ' + confirmacaoFichaInscricao.rgUf }}
                  </label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-3 p-1">
              <fieldset class="border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Data de Expedição</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.rgDataExp | DateFormat }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-3 p-1">
              <fieldset class="form-group border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">OAB</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.numOAB }}
                        {{ (confirmacaoFichaInscricao.orgaoExpOAB === '' || confirmacaoFichaInscricao.orgaoExpOAB === null) ? '' : ' / ' + confirmacaoFichaInscricao.orgaoExpOAB }}
                  </label>
                </div>
              </fieldset>
            </div>
          </div>
          <!-- FIM DO NASCIMENTO / IDENTIDADE / OAB -->

          <!-- INÍCIO DA NACIONALIDADE / NATURALIDADE / SEXO / ESCRITA -->
          <div class="row m-1">
            <div class="col-sm-3 p-1">
              <fieldset class="form-group border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Nacionalidade</legend>
                <div class="text-start">
                  <label>{{ getDescricaoById(confirmacaoFichaInscricao.nacionalidade, 'nacionalidade') }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-3 p-1">
              <fieldset class="form-group border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Naturalidade</legend>
                <div class="text-start">
                  <label>{{ getDescricaoById(confirmacaoFichaInscricao.naturalidade, 'naturalidade') }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-3 p-1">
              <fieldset class="form-group border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Sexo</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.sexo === 'M' ? 'Masculino' : 'Feminino' }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-3 p-1">
              <fieldset class="form-group border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Escrita</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.escrita === 'D' ? 'Destro': 'Canhoto'}}</label>
                </div>
              </fieldset>
            </div>
          </div>
          <!-- FIM DA NACIONALIDADE / NATURALIDADE / SEXO / ESCRITA  -->

          <!-- INÍCIO DO TURNO / CIÊNCIA DO CONCURSO -->
          <div class="row m-1">
            <div class="col-sm-2 p-1">
              <fieldset class="form-group border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Turno</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.codTurno === '1' ? 'Manhã' : 'Noite' }} ou
                        {{ confirmacaoFichaInscricao.codTurnoFake === '1' ? 'Manhã' : 'Noite' }}
                  </label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-2 p-1">
              <fieldset class="form-group border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Ciência do Concurso</legend>
                <div class="text-start">
                  <label>{{ getDescricaoById(confirmacaoFichaInscricao.cienciaConcurso, 'concurso') }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-6 p-1">
              <fieldset class="form-group border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Faculdade</legend>
                <div class="text-start">
                  <label>{{ getDescricaoById(confirmacaoFichaInscricao.instituicao.codigo, 'instituicao') }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-2 p-1">
              <fieldset class="form-group border rounded centralizado backgroundColor-fieldset">
                <legend class="float-none w-auto">Conclusão do Curso</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.instituicao.mesColacaoGrau }}
                        {{ (confirmacaoFichaInscricao.instituicao.anoColacaoGrau === '' || confirmacaoFichaInscricao.instituicao.anoColacaoGrau === null) ? '' : ' / ' + confirmacaoFichaInscricao.instituicao.anoColacaoGrau }}
                  </label>
                </div>
              </fieldset>
            </div>
          </div>
          <!-- FIM DO TURNO / CIÊNCIA DO CONCURSO -->

          <!-- INÍCIO DA FACULDADE / CONCLUSÃO DO CURSO -->
          <!-- <div class="row m-1">
          </div> -->
          <!-- FIM DA FACULDADE / CONCLUSÃO DO CURSO -->

          <!-- INÍCIO DO CONTATO -->
          <div class="row m-1">
            <div class="col-sm-3 p-1">
              <fieldset class="form-group border rounded backgroundColor-fieldset">
                <legend class="float-none w-auto">Tel. Residencial</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.telefone.residencial | phone }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-3 p-1">
              <fieldset class="form-group border rounded backgroundColor-fieldset">
                <legend class="float-none w-auto">Tel. Comercial</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.telefone.comercial | phone }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-3 p-1">
              <fieldset class="form-group border rounded backgroundColor-fieldset">
                <legend class="float-none w-auto">Celular</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.telefone.celular | phone }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-3 p-1">
              <fieldset class="form-group border rounded backgroundColor-fieldset">
                <legend class="float-none w-auto">E-mail</legend>
                <div class="text-start">
                  <label>{{ confirmacaoFichaInscricao.email }}</label>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="row m-1">
            <div class="col-sm-6 p-1" *ngIf="confirmacaoFichaInscricao.autorizaSMS">
              <fieldset class="form-group border rounded backgroundColor-fieldset">
                <div class="text-start" >
                  <label>
                    Autorizo o envio de informações via SMS.
                  </label>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-6 p-1" *ngIf="confirmacaoFichaInscricao.autorizaInfoPos">
              <fieldset class="form-group border rounded backgroundColor-fieldset">
                <div class="text-start" >
                  <label>
                    Aceito receber e-mails sobre os cursos de extensão e pós-graduação da EMERJ.
                  </label>
                </div>
              </fieldset>
            </div>
          </div>
          <!-- FIM DO CONTATO -->

          <!-- INÍCIO DO ENDEREÇO RESIDENCIAL -->
          <div class="row m-1">
            <div class="col-sm-12 p-1">
              <fieldset class="form-group border rounded">
                <legend class="float-none w-auto">Endereço Residencial</legend>
                <div class="row m-1">
                  <div class="col-sm-2">
                    <fieldset class="form-group border rounded backgroundColor-fieldset p-0">
                      <legend class="float-none w-auto">CEP</legend>
                      <div class="text-start">
                        <label>{{ confirmacaoFichaInscricao.endereco.cep | CEPFormat }}</label>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col-sm-4">
                    <fieldset class="form-group border rounded backgroundColor-fieldset p-0">
                      <legend class="float-none w-auto">Logradouro</legend>
                      <div class="text-start">
                        <label>{{ confirmacaoFichaInscricao.endereco.logradouro }}</label>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col-sm-1">
                    <fieldset class="form-group border rounded backgroundColor-fieldset p-0">
                      <legend class="float-none w-auto">Número</legend>
                      <div class="text-start">
                        <label>{{ confirmacaoFichaInscricao.endereco.numero }}</label>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col-sm-2">
                    <fieldset class="form-group border rounded backgroundColor-fieldset p-0">
                      <legend class="float-none w-auto">Bairro</legend>
                      <div class="text-start">
                        <label>{{ confirmacaoFichaInscricao.endereco.bairro }}</label>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col-sm-2">
                    <fieldset class="form-group border rounded backgroundColor-fieldset">
                      <legend class="float-none w-auto">Cidade</legend>
                      <div class="text-start">
                        <label>{{ confirmacaoFichaInscricao.endereco.cidade }}</label>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col-sm-1">
                    <fieldset class="form-group border rounded centralizado backgroundColor-fieldset">
                      <legend class="float-none w-auto">UF</legend>
                      <div class="text-start">
                        <label>{{ confirmacaoFichaInscricao.endereco.uf }}</label>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div class="row m-1">
                  <div class="col-sm-12">
                    <fieldset class="form-group border rounded backgroundColor-fieldset">
                      <legend class="float-none w-auto">Complemento</legend>
                      <div class="text-start">
                        <label>{{ confirmacaoFichaInscricao.endereco.complemento }}</label>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <!-- FIM DO ENDEREÇO RESIDENCIAL -->

        <!-- INÍCIO DO PORTADOR DE NECESSIDADES ESPECIAIS -->
        <div class="row m-1">
          <div class="col-sm-6 p-1">
            <fieldset class="form-group border rounded backgroundColor-fieldset">
              <legend class="float-none w-auto">É portador de necessidades especiais?</legend>
                  <div class="text-start">
                    <label>
                      {{ confirmacaoFichaInscricao.deficiencia.portador ? 'Sim - ' : 'Não' }}
                      {{ getDescricaoById(confirmacaoFichaInscricao.deficiencia.codigo, 'deficiencia') }}
                    </label>
                  </div>
            </fieldset>
          </div>
          <div class="col-sm-6 p-1">
            <fieldset class="form-group border rounded backgroundColor-fieldset">
              <legend class="float-none w-auto">Necessita de apoio?</legend>
                  <div class="text-start">
                    <label>
                      {{ confirmacaoFichaInscricao.deficiencia.necessitaApoio ? 'Sim - ' : 'Não' }}
                      {{ confirmacaoFichaInscricao.deficiencia.observacao }}</label>
                  </div>
            </fieldset>
          </div>
        </div>
        <div class="row m-1" *ngIf="isExibeOpcaoCotista">
          <div class="col-sm-6 p-1">
            <fieldset class="form-group border rounded backgroundColor-fieldset">
              <legend class="float-none w-auto">Isento IRPF?</legend>
                  <div class="text-start">
                    <label>
                      {{ confirmacaoFichaInscricao.indIsentoIR == 'S' ? 'Sim' : 'Não' }}
                    </label>
                  </div>
            </fieldset>
          </div>
          <div class="col-sm-6 p-1">
            <fieldset class="form-group border rounded backgroundColor-fieldset">
              <legend class="float-none w-auto">Desempregado?</legend>
                  <div class="text-start">
                    <label>
                      {{ confirmacaoFichaInscricao.indDesempregado == 'S' ? 'Sim' : 'Não' }}
                    </label>
                  </div>
            </fieldset>
          </div>
        </div>
        <!-- FIM DO PORTADOR DE NECESSIDADES ESPECIAIS -->

        <!--INICIO DOS DOCUMENTOS ENVIADOS PARA COTISTA-->
        <div class="row m-2" *ngIf="isExibeOpcaoCotista">
          <fieldset class="col_sm_12 border  p-0 well well-sm" id="fstDadosGerais">
              <legend  class="float-none" style="width:auto;">
                  Documentos - Cotista
                  <span id="lblTxtSpanDoc" class="fw-bold" (click)="mostrarEsconderDoc()">{{ textoSpanDoc }}</span>
              </legend>
              <div *ngIf="exibirDocs">
                  <div id="docs" class="row m-1 mt-0 mb-0"
                      *ngFor="let doc of confirmacaoFichaInscricao.documentos; let even = even; let odd = odd;"
                      [ngClass]="odd ? 'odd' : 'even'">
                          <div class="col-sm-6 p-0 m-0"><label class="p-0">{{ doc.descDoc }}</label></div>
                          <div class="col-sm-6 p-0 m-0"><label class="p-0">{{ doc.nomeArquivo }}</label></div>
                  </div>
              </div>
          </fieldset>
      </div>

        <div class="row m-1">
          <div class="col-sm-12 p-1">
            <fieldset class="form-group border rounded backgroundColor-fieldset">
              <legend class="float-none w-auto">Atenção:</legend>
              <div class="text-start p-1">
                <label class="d-block">1. Redobre a atenção no preenchimento dos campos E-MAIL e TELEFONE CELULAR, pois havendo necessidade, a escola entrará em contato com o candidato;</label>
                <label class="d-block">2. Desabilite o filtro anti-spam do seu servidor de email para o recebimento da confirmação de inscrição;</label>
                <label class="d-block">3. Após a confirmação dos dados os mesmos não poderão ser alterados.</label>
              </div>
              </fieldset>
          </div>
        </div>
        <div class="row m-1">
          <div class="col-sm-12 p-1">
            <fieldset class="form-group border rounded backgroundColor-fieldset">
              <div class="form-check inline fw-normal">
                <input type="checkbox"
                class="form-check-input"
                name="chkAcordo"
                formControlName="DeAcordo"
                (change)="aceiteContrato()" />
                  <label>
                    Li e concordo com os termos do Edital de Concurso Público para Seleção e Ingresso na EMERJ - {{ v_periodoAnoAC }}.
                  </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row m-1">
            <fieldset class="form-group border rounded backgroundColor-fieldset">
              <legend class="float-none w-auto">Confirma os dados exibidos acima?</legend>
              <div class="col-sm-12 text-start m-1">
                <button type="button"
                        class="btn btn-sm btn-primary azulTopo"
                        name="btnVoltar"
                        data-toggle="button"
                        (click)="btnRetornarTelaAnterior()">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;Voltar
                </button>
                &nbsp;&nbsp;&nbsp;
                <button type="button"
                        class="btn btn-sm btn-primary azulTopo"
                        name="btnSim"
                        data-toggle="button"
                        [disabled]="!desabilitarBtnSim"
                        (click)="onSubmitForm(confirmacaoFichaInscricao)">Sim
                </button>
                &nbsp;&nbsp;&nbsp;
                <button type="button"
                        class="btn btn-sm btn-danger"
                        name="btnNao"
                        data-toggle="button"
                        (click)="btnNao()">Não
                </button>
              </div>
            </fieldset>
        </div>
      </form>
    </div>


